import React from 'react';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {NumericField} from '@views/purchases/fields/materials/NumericField';

export function QuantityField(props: IListColumnProps) {
    return <NumericField {...props} step={0.0001}/>;
}
